import React from 'react'
import ReactDOM from 'react-dom'
import './global.scss'
import App from './App'
import { Provider } from 'react-redux'
import store from './redux/configureStore'

ReactDOM.render(
  <React.StrictMode>
    <Provider store={store}>
      <App />
    </Provider>
  </React.StrictMode>,
  document.getElementById('root'),
)
